import {Auth} from "aws-amplify";
import {KitchenEvent} from "../types/CalendarEvent";

export const putKitchenEvent = async (
    kitchenEvent: KitchenEvent
) => {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();

    const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/api/kitchen`, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${idToken}`,
        },

        body: JSON.stringify({
            DateID: kitchenEvent.DateID,
            Date: Math.floor(kitchenEvent.Date.getTime() / 1000),
            PeopleServedAM: kitchenEvent.PeopleServedAM,
            PeopleServedPM: kitchenEvent.PeopleServedPM,
        }),
    });

    if (!response.ok) {
        const responseBody = await response.json();
        throw new Error(responseBody.error || `HTTP error! status: ${response.status}`);
    }

    return response.json();
};


export const getKitchenEvents = async (startDate: Date, endDate: Date): Promise<KitchenEvent[]> => {
    const session = await Auth.currentSession();
    const idToken = session.getIdToken().getJwtToken();

    // Convert dates to Unix timestamp (seconds since 1970)
    const startUnix = Math.floor(startDate.getTime() / 1000);
    const endUnix = Math.floor(endDate.getTime() / 1000);

    const requestOptions = {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${idToken}`,
        },
    };

    const url = new URL(`${process.env.REACT_APP_API_ENDPOINT}/api/kitchen`);
    url.searchParams.append('start', startUnix.toString());
    url.searchParams.append('end', endUnix.toString());

    try {
        const response = await fetch(url, requestOptions);
        const rawData = await response.json();

        // the raw data should match the KitchenEvent interface
        return rawData.map((event: any) => ({
               DateID: event.DateID,
                Date: new Date(event.Date * 1000),
                PeopleServedAM: event.PeopleServedAM,
                PeopleServedPM: event.PeopleServedPM,
        }));

    } catch (error) {
        return [];
    }
};

